<div class="rcs-carousel-builder">
  <div class="card">
    <div class="card-header">RCS Carousel</div>
    
    <div class="form-group">
      <label for="cardWidth">Carousel Width</label>
      <select
        id="cardWidth"
        [(ngModel)]="carousel.width"
        (ngModelChange)="onCarouselChange()">
        <option value="SMALL">Small</option>
        <option value="MEDIUM">Medium</option>
      </select>
    </div>

    <div class="cards-section">
      <div class="section-header">
        <h3>Carousel Cards ({{ carousel.cards.length }})</h3>
        <button class="btn btn-primary btn-sm" (click)="addNewCard()" [disabled]="carousel.cards.length >= 10">Add Card</button>
      </div>
      <small class="help-text" [class.error-text]="carousel.cards.length < 2 || carousel.cards.length > 10">
        <strong>Required:</strong> 2-10 cards. All media must have the same height.
      </small>

      <div class="cards-list">
        <div 
          class="card-preview-item"
          *ngFor="let card of carousel.cards; let i = index"
          [class.active]="i === currentCardIndex"
          (click)="selectCard(i)">
          <div class="card-preview-header">
            <span class="card-number">Card {{ i + 1 }}</span>
            <button 
              class="btn-remove-small"
              (click)="removeCard(i); $event.stopPropagation()"
              *ngIf="carousel.cards.length > 2"
              title="Remove card">
              ×
            </button>
          </div>
          <div class="card-preview-thumbnail" *ngIf="(card.media && card.media.url) || (card.thumbnail && card.thumbnail.url)">
            <img [src]="(card.media && card.media.url) ? card.media.url : (card.thumbnail && card.thumbnail.url ? card.thumbnail.url : '')" alt="Card preview" onerror="this.style.display='none'">
          </div>
          <div class="card-preview-content">
            <strong>{{ card.title || 'Untitled Card' }}</strong>
            <p>{{ card.description || 'No description' }}</p>
            <div class="card-preview-meta" *ngIf="card.suggestions && card.suggestions.length > 0">
              <span class="meta-badge">{{ card.suggestions.length }} suggestion{{ card.suggestions.length > 1 ? 's' : '' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card-editor" *ngIf="currentCardIndex >= 0">
      <div class="editor-header">
        <h3>Edit Card {{ currentCardIndex + 1 }}</h3>
      </div>

      <div class="form-group">
        <label>Card Title</label>
        <div class="input-group">
          <input
            #titleInput
            type="text"
            [(ngModel)]="editingCard.title"
            (ngModelChange)="onCardFieldChange()"
            (blur)="validateCardField('title', editingCard.title)"
            (click)="rememberSelection($event, 'title')"
            (keyup)="rememberSelection($event, 'title')"
            (mouseup)="rememberSelection($event, 'title')"
            [class.error]="cardErrors['title']"
            placeholder="Enter card title">
          <div class="input-group-append">
            <button
              mdbTooltip="Insert Wildcard"
              placement="top"
              class="input-group-text insert-wilcard"
              (click)="_formGroupInsertWildcard.reset(); openWildcard('title', titleInput)">
              <span class="insert-wilcard-span">W</span>
            </button>
          </div>
        </div>
        <small class="error-text" *ngIf="cardErrors['title']">{{ cardErrors['title'] }}</small>
      </div>

      <div class="form-group">
        <label>Description</label>
        <div class="input-group">
          <textarea
            #descriptionInput
            [(ngModel)]="editingCard.description"
            (ngModelChange)="onCardFieldChange()"
            (blur)="validateCardField('description', editingCard.description)"
            (click)="rememberSelection($event, 'description')"
            (keyup)="rememberSelection($event, 'description')"
            (mouseup)="rememberSelection($event, 'description')"
            [class.error]="cardErrors['description']"
            placeholder="Enter card description"
            rows="3">
          </textarea>
          <div class="input-group-append">
            <button
              mdbTooltip="Insert Wildcard"
              placement="top"
              class="input-group-text insert-wilcard"
              (click)="_formGroupInsertWildcard.reset(); openWildcard('description', descriptionInput)">
              <span class="insert-wilcard-span">W</span>
            </button>
          </div>
        </div>
        <small class="error-text" *ngIf="cardErrors['description']">{{ cardErrors['description'] }}</small>
      </div>

      <div class="form-group">
        <label>Media URL</label>
        <div class="input-with-button">
          <input
            type="url"
            [ngModel]="editingCard.media?.url"
            (ngModelChange)="editingCard.media!.url = $event; onMediaUrlChange()"
            (blur)="validateCardField('mediaUrl', editingCard.media?.url)"
            [class.error]="cardErrors['mediaUrl']"
            placeholder="https://example.com/image.jpg">
          <button type="button" class="btn-media-server" (click)="openMediaServerModal('media')">Load from Media Server</button>
        </div>
        <small class="error-text" *ngIf="cardErrors['mediaUrl']">{{ cardErrors['mediaUrl'] }}</small>
        <div class="media-preview" *ngIf="editingCard.media?.url">
          <img [src]="editingCard.media.url" alt="Media preview" (error)="onMediaLoadError('mediaUrl')">
        </div>
      </div>

      <div class="form-group">
        <label>Media Height</label>
        <select
          [ngModel]="editingCard.media?.height"
          (ngModelChange)="editingCard.media!.height = $event; onCardFieldChange()">
          <option value="SHORT">Short</option>
          <option value="MEDIUM">Medium</option>
          <option value="TALL">Tall</option>
        </select>
      </div>

      <div class="form-group">
        <label>Thumbnail URL (Optional)</label>
        <div class="input-with-button">
          <input
            type="url"
            [ngModel]="editingCard.thumbnail?.url"
            (ngModelChange)="editingCard.thumbnail = editingCard.thumbnail || { url: '', height: 'MEDIUM' }; editingCard.thumbnail!.url = $event; onCardFieldChange()"
            (blur)="validateCardField('thumbnailUrl', editingCard.thumbnail?.url)"
            [class.error]="cardErrors['thumbnailUrl']"
            placeholder="https://example.com/thumbnail.jpg">
          <button type="button" class="btn-media-server" (click)="openMediaServerModal('thumbnail')">Load from Media Server</button>
        </div>
        <small class="error-text" *ngIf="cardErrors['thumbnailUrl']">{{ cardErrors['thumbnailUrl'] }}</small>
        <small class="help-text">Thumbnail image for the carousel card</small>
        <div class="media-preview" *ngIf="editingCard.thumbnail?.url">
          <img [src]="editingCard.thumbnail.url" alt="Thumbnail preview" (error)="onMediaLoadError('thumbnailUrl')">
        </div>
      </div>

      <div class="form-group" *ngIf="editingCard.thumbnail?.url">
        <label>Thumbnail Height</label>
        <select
          [ngModel]="editingCard.thumbnail?.height"
          (ngModelChange)="editingCard.thumbnail!.height = $event; onCardFieldChange()">
          <option value="SHORT">Short</option>
          <option value="MEDIUM">Medium</option>
          <option value="TALL">Tall</option>
        </select>
      </div>

      <div class="suggestions-section">
        <div class="section-header">
          <h4>Card Suggestions</h4>
        </div>

        <div class="suggestions-list" *ngIf="editingCard.suggestions && editingCard.suggestions.length > 0">
          <div class="suggestion-item" *ngFor="let suggestion of editingCard.suggestions; let i = index">
            <!-- Display mode -->
            <div *ngIf="editingCardSuggestionIndex !== i" class="suggestion-content">
              <strong>{{ suggestion.displayText }}</strong>
              <span class="suggestion-type">({{ suggestion.type }})</span>
              <div class="suggestion-actions">
                <button class="btn-edit" (click)="editCardSuggestion(i)">Edit</button>
                <button class="btn-remove" (click)="removeSuggestion(i)">Remove</button>
              </div>
            </div>
            
            <!-- Edit mode -->
            <div *ngIf="editingCardSuggestionIndex === i" class="suggestion-edit-form">
              <div class="form-group">
                <label>Suggestion Type</label>
                <select [(ngModel)]="editingCardSuggestion.type" (ngModelChange)="onEditingCardSuggestionTypeChange()">
                  <option [value]="SuggestionType.REPLY">Reply</option>
                  <option [value]="SuggestionType.OPEN_URL">Open URL</option>
                  <option [value]="SuggestionType.DIAL_PHONE">Dial Phone</option>
                  <option [value]="SuggestionType.VIEW_LOCATION">View Location</option>
                  <option [value]="SuggestionType.CALENDAR_EVENT">Calendar Event</option>
                </select>
              </div>
              
              <div class="form-group">
                <label>Display Text</label>
                <input
                  type="text"
                  maxlength="25"
                  [(ngModel)]="editingCardSuggestion.displayText"
                  [class.error]="editingCardSuggestionErrors['displayText']"
                  placeholder="Button text (max 25 chars)">
                <small class="char-count">{{ editingCardSuggestion.displayText?.length || 0 }}/25</small>
                <small class="error-text" *ngIf="editingCardSuggestionErrors['displayText']">{{ editingCardSuggestionErrors['displayText'] }}</small>
              </div>

              <!-- Open URL fields -->
              <div class="form-group" *ngIf="editingCardSuggestion.type === SuggestionType.OPEN_URL">
                <label>URL</label>
                <input
                  type="url"
                  [(ngModel)]="editingCardSuggestion.url"
                  [class.error]="editingCardSuggestionErrors['url']"
                  placeholder="https://example.com">
                <small class="error-text" *ngIf="editingCardSuggestionErrors['url']">{{ editingCardSuggestionErrors['url'] }}</small>
              </div>

              <!-- Dial Phone fields -->
              <div class="form-group" *ngIf="editingCardSuggestion.type === SuggestionType.DIAL_PHONE">
                <label>Phone Number</label>
                <input
                  type="tel"
                  [(ngModel)]="editingCardSuggestion.phone"
                  [class.error]="editingCardSuggestionErrors['phone']"
                  placeholder="+441234567890">
                <small class="error-text" *ngIf="editingCardSuggestionErrors['phone']">{{ editingCardSuggestionErrors['phone'] }}</small>
              </div>

              <!-- View Location fields -->
              <div *ngIf="editingCardSuggestion.type === SuggestionType.VIEW_LOCATION">
                <div class="form-group">
                  <label>Address (Optional)</label>
                  <input
                    type="text"
                    [(ngModel)]="editingCardSuggestion.address"
                    placeholder="Street address">
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>Latitude</label>
                    <input
                      type="number"
                      [(ngModel)]="editingCardSuggestion.latitude"
                      [class.error]="editingCardSuggestionErrors['latitude']"
                      placeholder="43.649269"
                      step="any">
                    <small class="error-text" *ngIf="editingCardSuggestionErrors['latitude']">{{ editingCardSuggestionErrors['latitude'] }}</small>
                  </div>
                  <div class="form-group">
                    <label>Longitude</label>
                    <input
                      type="number"
                      [(ngModel)]="editingCardSuggestion.longitude"
                      [class.error]="editingCardSuggestionErrors['longitude']"
                      placeholder="-79.378423"
                      step="any">
                    <small class="error-text" *ngIf="editingCardSuggestionErrors['longitude']">{{ editingCardSuggestionErrors['longitude'] }}</small>
                  </div>
                </div>
              </div>

              <!-- Calendar Event fields -->
              <div *ngIf="editingCardSuggestion.type === SuggestionType.CALENDAR_EVENT">
                <div class="form-group">
                  <label>Meeting Title</label>
                  <input
                    type="text"
                    [(ngModel)]="editingCardSuggestion.meetingTitle"
                    [class.error]="editingCardSuggestionErrors['meetingTitle']"
                    placeholder="Test Drive">
                  <small class="error-text" *ngIf="editingCardSuggestionErrors['meetingTitle']">{{ editingCardSuggestionErrors['meetingTitle'] }}</small>
                </div>
                <div class="form-group">
                  <label>Meeting Description (Optional)</label>
                  <textarea
                    [(ngModel)]="editingCardSuggestion.meetingDescription"
                    [class.error]="editingCardSuggestionErrors['meetingDescription']"
                    placeholder="Meeting description"
                    rows="2">
                  </textarea>
                  <small class="error-text" *ngIf="editingCardSuggestionErrors['meetingDescription']">{{ editingCardSuggestionErrors['meetingDescription'] }}</small>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label>Start Time (ISO 8601)</label>
                    <input
                      type="datetime-local"
                      [(ngModel)]="editingCardSuggestion.startTime"
                      [class.error]="editingCardSuggestionErrors['startTime']"
                      placeholder="2025-12-01T09:00:00Z">
                    <small class="error-text" *ngIf="editingCardSuggestionErrors['startTime']">{{ editingCardSuggestionErrors['startTime'] }}</small>
                  </div>
                  <div class="form-group">
                    <label>End Time (ISO 8601)</label>
                    <input
                      type="datetime-local"
                      [(ngModel)]="editingCardSuggestion.endTime"
                      [class.error]="editingCardSuggestionErrors['endTime']"
                      placeholder="2025-12-05T17:00:00Z">
                    <small class="error-text" *ngIf="editingCardSuggestionErrors['endTime']">{{ editingCardSuggestionErrors['endTime'] }}</small>
                  </div>
                </div>
              </div>

              <div class="edit-actions">
                <button class="btn btn-primary btn-sm" (click)="saveEditingCardSuggestion()">Save</button>
                <button class="btn btn-secondary btn-sm" (click)="cancelEditingCardSuggestion()">Cancel</button>
              </div>
            </div>
          </div>
        </div>

        <div class="add-suggestion">
          <div class="form-group">
            <label>Suggestion Type</label>
            <select [(ngModel)]="newSuggestion.type" (ngModelChange)="onSuggestionTypeChange()">
              <option [value]="SuggestionType.REPLY">Reply</option>
              <option [value]="SuggestionType.OPEN_URL">Open URL</option>
              <option [value]="SuggestionType.DIAL_PHONE">Dial Phone</option>
            </select>
          </div>
          <div class="form-group">
            <label>Display Text</label>
            <input
              type="text"
              maxlength="25"
              [(ngModel)]="newSuggestion.displayText"
              (blur)="validateSuggestionField('displayText', newSuggestion.displayText)"
              [class.error]="suggestionErrors['displayText']"
              placeholder="Button text (max 25 chars)">
            <small class="char-count">{{ newSuggestion.displayText?.length || 0 }}/25</small>
            <small class="error-text" *ngIf="suggestionErrors['displayText']">{{ suggestionErrors['displayText'] }}</small>
          </div>

          <div class="form-group" *ngIf="newSuggestion.type === SuggestionType.OPEN_URL">
            <label>URL</label>
            <input
              type="url"
              [(ngModel)]="newSuggestion.url"
              (blur)="validateSuggestionField('url', newSuggestion.url)"
              [class.error]="suggestionErrors['url']"
              placeholder="https://example.com">
            <small class="error-text" *ngIf="suggestionErrors['url']">{{ suggestionErrors['url'] }}</small>
          </div>

          <div class="form-group" *ngIf="newSuggestion.type === SuggestionType.DIAL_PHONE">
            <label>Phone Number</label>
            <input
              type="tel"
              [(ngModel)]="newSuggestion.phone"
              (blur)="validateSuggestionField('phone', newSuggestion.phone)"
              [class.error]="suggestionErrors['phone']"
              placeholder="+441234567890">
            <small class="error-text" *ngIf="suggestionErrors['phone']">{{ suggestionErrors['phone'] }}</small>
          </div>

          <button class="btn btn-primary btn-sm" (click)="addSuggestion()">Add Suggestion</button>
        </div>
      </div>
    </div>

    <!-- Carousel-level Suggestions -->
    <div class="carousel-suggestions-section">
      <div class="section-header">
        <h3>Carousel Suggestions (Global Actions)</h3>
        <small>Add suggestions that appear for the entire carousel</small>
      </div>

      <div class="suggestions-list" *ngIf="carouselSuggestions.length > 0">
        <div class="suggestion-item" *ngFor="let suggestion of carouselSuggestions; let i = index">
          <!-- Display mode -->
          <div *ngIf="editingCarouselSuggestionIndex !== i" class="suggestion-content">
            <strong>{{ suggestion.displayText }}</strong>
            <span class="suggestion-type">({{ suggestion.type }})</span>
            <div class="suggestion-actions">
              <button class="btn-edit" (click)="editCarouselSuggestion(i)">Edit</button>
              <button class="btn-remove" (click)="removeCarouselSuggestion(i)">Remove</button>
            </div>
          </div>
          
          <!-- Edit mode -->
          <div *ngIf="editingCarouselSuggestionIndex === i" class="suggestion-edit-form">
            <div class="form-group">
              <label>Suggestion Type</label>
              <select [(ngModel)]="editingCarouselSuggestion.type" (ngModelChange)="onEditingCarouselSuggestionTypeChange()">
                <option [value]="SuggestionType.REPLY">Reply</option>
                <option [value]="SuggestionType.OPEN_URL">Open URL</option>
                <option [value]="SuggestionType.DIAL_PHONE">Dial Phone</option>
                <option [value]="SuggestionType.VIEW_LOCATION">View Location</option>
                <option [value]="SuggestionType.CALENDAR_EVENT">Calendar Event</option>
              </select>
            </div>
            
            <div class="form-group">
              <label>Display Text</label>
              <input
                type="text"
                maxlength="25"
                [(ngModel)]="editingCarouselSuggestion.displayText"
                [class.error]="editingCarouselSuggestionErrors['displayText']"
                placeholder="Button text (max 25 chars)">
              <small class="char-count">{{ editingCarouselSuggestion.displayText?.length || 0 }}/25</small>
              <small class="error-text" *ngIf="editingCarouselSuggestionErrors['displayText']">{{ editingCarouselSuggestionErrors['displayText'] }}</small>
            </div>

            <!-- Open URL fields -->
            <div class="form-group" *ngIf="editingCarouselSuggestion.type === SuggestionType.OPEN_URL">
              <label>URL</label>
              <input
                type="url"
                [(ngModel)]="editingCarouselSuggestion.url"
                [class.error]="editingCarouselSuggestionErrors['url']"
                placeholder="https://example.com">
              <small class="error-text" *ngIf="editingCarouselSuggestionErrors['url']">{{ editingCarouselSuggestionErrors['url'] }}</small>
            </div>

            <!-- Dial Phone fields -->
            <div class="form-group" *ngIf="editingCarouselSuggestion.type === SuggestionType.DIAL_PHONE">
              <label>Phone Number</label>
              <input
                type="tel"
                [(ngModel)]="editingCarouselSuggestion.phone"
                [class.error]="editingCarouselSuggestionErrors['phone']"
                placeholder="+441234567890">
              <small class="error-text" *ngIf="editingCarouselSuggestionErrors['phone']">{{ editingCarouselSuggestionErrors['phone'] }}</small>
            </div>

            <!-- View Location fields -->
            <div *ngIf="editingCarouselSuggestion.type === SuggestionType.VIEW_LOCATION">
              <div class="form-group">
                <label>Address (Optional)</label>
                <input
                  type="text"
                  [(ngModel)]="editingCarouselSuggestion.address"
                  placeholder="Street address">
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Latitude</label>
                  <input
                    type="number"
                    [(ngModel)]="editingCarouselSuggestion.latitude"
                    [class.error]="editingCarouselSuggestionErrors['latitude']"
                    placeholder="43.649269"
                    step="any">
                  <small class="error-text" *ngIf="editingCarouselSuggestionErrors['latitude']">{{ editingCarouselSuggestionErrors['latitude'] }}</small>
                </div>
                <div class="form-group">
                  <label>Longitude</label>
                  <input
                    type="number"
                    [(ngModel)]="editingCarouselSuggestion.longitude"
                    [class.error]="editingCarouselSuggestionErrors['longitude']"
                    placeholder="-79.378423"
                    step="any">
                  <small class="error-text" *ngIf="editingCarouselSuggestionErrors['longitude']">{{ editingCarouselSuggestionErrors['longitude'] }}</small>
                </div>
              </div>
            </div>

            <!-- Calendar Event fields -->
            <div *ngIf="editingCarouselSuggestion.type === SuggestionType.CALENDAR_EVENT">
              <div class="form-group">
                <label>Meeting Title</label>
                <input
                  type="text"
                  [(ngModel)]="editingCarouselSuggestion.meetingTitle"
                  [class.error]="editingCarouselSuggestionErrors['meetingTitle']"
                  placeholder="Test Drive">
                <small class="error-text" *ngIf="editingCarouselSuggestionErrors['meetingTitle']">{{ editingCarouselSuggestionErrors['meetingTitle'] }}</small>
              </div>
              <div class="form-group">
                <label>Meeting Description (Optional)</label>
                <textarea
                  [(ngModel)]="editingCarouselSuggestion.meetingDescription"
                  [class.error]="editingCarouselSuggestionErrors['meetingDescription']"
                  placeholder="Meeting description"
                  rows="2">
                </textarea>
                <small class="error-text" *ngIf="editingCarouselSuggestionErrors['meetingDescription']">{{ editingCarouselSuggestionErrors['meetingDescription'] }}</small>
              </div>
              <div class="form-row">
                <div class="form-group">
                  <label>Start Time (ISO 8601)</label>
                  <input
                    type="datetime-local"
                    [(ngModel)]="editingCarouselSuggestion.startTime"
                    [class.error]="editingCarouselSuggestionErrors['startTime']"
                    placeholder="2025-12-01T09:00:00Z">
                  <small class="error-text" *ngIf="editingCarouselSuggestionErrors['startTime']">{{ editingCarouselSuggestionErrors['startTime'] }}</small>
                </div>
                <div class="form-group">
                  <label>End Time (ISO 8601)</label>
                  <input
                    type="datetime-local"
                    [(ngModel)]="editingCarouselSuggestion.endTime"
                    [class.error]="editingCarouselSuggestionErrors['endTime']"
                    placeholder="2025-12-05T17:00:00Z">
                  <small class="error-text" *ngIf="editingCarouselSuggestionErrors['endTime']">{{ editingCarouselSuggestionErrors['endTime'] }}</small>
                </div>
              </div>
            </div>

            <div class="edit-actions">
              <button class="btn btn-primary btn-sm" (click)="saveEditingCarouselSuggestion()">Save</button>
              <button class="btn btn-secondary btn-sm" (click)="cancelEditingCarouselSuggestion()">Cancel</button>
            </div>
          </div>
        </div>
      </div>

      <div class="add-suggestion">
        <div class="form-group">
          <label>Suggestion Type</label>
          <select [(ngModel)]="newCarouselSuggestion.type" (ngModelChange)="onCarouselSuggestionTypeChange()">
            <option [value]="SuggestionType.REPLY">Reply</option>
            <option [value]="SuggestionType.OPEN_URL">Open URL</option>
            <option [value]="SuggestionType.DIAL_PHONE">Dial Phone</option>
            <option [value]="SuggestionType.VIEW_LOCATION">View Location</option>
            <option [value]="SuggestionType.CALENDAR_EVENT">Calendar Event</option>
          </select>
        </div>
        <div class="form-group">
          <label>Display Text</label>
          <input
            type="text"
            maxlength="25"
            [(ngModel)]="newCarouselSuggestion.displayText"
            (blur)="validateCarouselSuggestionField('displayText', newCarouselSuggestion.displayText)"
            [class.error]="carouselSuggestionErrors['displayText']"
            placeholder="Button text (max 25 chars)">
          <small class="char-count">{{ newCarouselSuggestion.displayText?.length || 0 }}/25</small>
          <small class="error-text" *ngIf="carouselSuggestionErrors['displayText']">{{ carouselSuggestionErrors['displayText'] }}</small>
        </div>

        <div class="form-group" *ngIf="newCarouselSuggestion.type === SuggestionType.OPEN_URL">
          <label>URL</label>
          <input
            type="url"
            [(ngModel)]="newCarouselSuggestion.url"
            (blur)="validateCarouselSuggestionField('url', newCarouselSuggestion.url)"
            [class.error]="carouselSuggestionErrors['url']"
            placeholder="https://example.com">
          <small class="error-text" *ngIf="carouselSuggestionErrors['url']">{{ carouselSuggestionErrors['url'] }}</small>
        </div>

        <div class="form-group" *ngIf="newCarouselSuggestion.type === SuggestionType.DIAL_PHONE">
          <label>Phone Number</label>
          <input
            type="tel"
            [(ngModel)]="newCarouselSuggestion.phone"
            (blur)="validateCarouselSuggestionField('phone', newCarouselSuggestion.phone)"
            [class.error]="carouselSuggestionErrors['phone']"
            placeholder="+441234567890">
          <small class="error-text" *ngIf="carouselSuggestionErrors['phone']">{{ carouselSuggestionErrors['phone'] }}</small>
        </div>

        <div *ngIf="newCarouselSuggestion.type === SuggestionType.VIEW_LOCATION">
          <div class="form-group">
            <label>Address (Optional)</label>
            <input
              type="text"
              [(ngModel)]="newCarouselSuggestion.address"
              placeholder="Street address">
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Latitude</label>
              <input
                type="number"
                [(ngModel)]="newCarouselSuggestion.latitude"
                (blur)="validateCarouselSuggestionField('latitude', newCarouselSuggestion.latitude)"
                [class.error]="carouselSuggestionErrors['latitude']"
                placeholder="43.649269"
                step="any">
              <small class="error-text" *ngIf="carouselSuggestionErrors['latitude']">{{ carouselSuggestionErrors['latitude'] }}</small>
            </div>
            <div class="form-group">
              <label>Longitude</label>
              <input
                type="number"
                [(ngModel)]="newCarouselSuggestion.longitude"
                (blur)="validateCarouselSuggestionField('longitude', newCarouselSuggestion.longitude)"
                [class.error]="carouselSuggestionErrors['longitude']"
                placeholder="-79.378423"
                step="any">
              <small class="error-text" *ngIf="carouselSuggestionErrors['longitude']">{{ carouselSuggestionErrors['longitude'] }}</small>
            </div>
          </div>
        </div>

        <div *ngIf="newCarouselSuggestion.type === SuggestionType.CALENDAR_EVENT">
          <div class="form-group">
            <label>Meeting Title</label>
            <input
              type="text"
              [(ngModel)]="newCarouselSuggestion.meetingTitle"
              (blur)="validateCarouselSuggestionField('meetingTitle', newCarouselSuggestion.meetingTitle)"
              [class.error]="carouselSuggestionErrors['meetingTitle']"
              placeholder="Test Drive">
            <small class="error-text" *ngIf="carouselSuggestionErrors['meetingTitle']">{{ carouselSuggestionErrors['meetingTitle'] }}</small>
          </div>
          <div class="form-group">
            <label>Meeting Description (Optional)</label>
            <textarea
              [(ngModel)]="newCarouselSuggestion.meetingDescription"
              (blur)="validateCarouselSuggestionField('meetingDescription', newCarouselSuggestion.meetingDescription)"
              [class.error]="carouselSuggestionErrors['meetingDescription']"
              placeholder="Meeting description"
              rows="2">
            </textarea>
            <small class="error-text" *ngIf="carouselSuggestionErrors['meetingDescription']">{{ carouselSuggestionErrors['meetingDescription'] }}</small>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label>Start Time (ISO 8601)</label>
              <input
                type="datetime-local"
                [(ngModel)]="newCarouselSuggestion.startTime"
                (blur)="validateCarouselSuggestionField('startTime', newCarouselSuggestion.startTime)"
                [class.error]="carouselSuggestionErrors['startTime']"
                placeholder="2025-12-01T09:00:00Z">
              <small class="error-text" *ngIf="carouselSuggestionErrors['startTime']">{{ carouselSuggestionErrors['startTime'] }}</small>
            </div>
            <div class="form-group">
              <label>End Time (ISO 8601)</label>
              <input
                type="datetime-local"
                [(ngModel)]="newCarouselSuggestion.endTime"
                (blur)="validateCarouselSuggestionField('endTime', newCarouselSuggestion.endTime)"
                [class.error]="carouselSuggestionErrors['endTime']"
                placeholder="2025-12-05T17:00:00Z">
              <small class="error-text" *ngIf="carouselSuggestionErrors['endTime']">{{ carouselSuggestionErrors['endTime'] }}</small>
            </div>
          </div>
        </div>

        <button class="btn btn-primary" (click)="addCarouselSuggestion()">Add Carousel Suggestion</button>
      </div>
    </div>
    <div class="form-group margin-top-20">
      <label for="fallbackText">Fallback Text</label>
      <div class="input-group">
        <textarea
          #fallbackInput
          id="fallbackText"
          [(ngModel)]="fallbackText"
          (ngModelChange)="onFallbackTextChange()"
          (blur)="validateFallbackText()"
          (click)="rememberSelection($event, 'fallback')"
          (keyup)="rememberSelection($event, 'fallback')"
          (mouseup)="rememberSelection($event, 'fallback')"
          [class.error]="fallbackTextError"
          placeholder="Enter fallback text for non-RCS devices"
          rows="6">
        </textarea>
      </div>
      <small class="help-text" *ngIf="!fallbackTextError">This text will be sent to devices that don't support RCS.</small>
      <small class="error-text" *ngIf="fallbackTextError">{{ fallbackTextError }}</small>
    </div>

    <div class="form-group">
      <label for="sender">Fallback Sender</label>
      <select
        id="sender"
        [(ngModel)]="selectedSenderId"
        (ngModelChange)="onSenderChange()"
        class="form-control fallback-sender-select"
        required>
        <option value="0" disabled>Select Sender</option>
        <option *ngFor="let sender of _clientInboxSelectListOptions" [ngValue]="sender.value">
          {{sender.label}}
        </option>
      </select>
      <small class="error-text" *ngIf="senderError">{{ senderError }}</small>
    </div>
  </div>
</div>

<div mdbModal #mediaServerModal="mdbModal" class="modal fade right modal-overflow" tabindex="-1" role="dialog"
  aria-labelledby="mediaServerModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="closeMediaServer()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Select Files From Media Server</h4>
      </div>
      <div class="modal-body">
        <app-media-server *ngIf="_showMediaServer"></app-media-server>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" mdbBtn color="secondary" class="waves-light" aria-label="Close"
          (click)="closeMediaServer()" mdbWavesEffect>Close</button>
        <button type="button" mdbBtn color="primary" class="relative waves-light" (click)="applyMediaFromServer()"
          mdbWavesEffect>OK!</button>
      </div>
    </div>
  </div>
</div>

<div mdbModal #insertWildcardModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="insertWildcardModal" aria-hidden="true">
  <div class="modal-dialog insert-wilcard-modal" role="document">
    <div class="modal-content rounded-lg">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="insertWildcardModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="createFolderModalLabel">Insert Wildcard</h4>
      </div>
      <form [formGroup]="_formGroupInsertWildcard" (ngSubmit)="insertWildcardModalSubmit()">
        <div class="modal-body">
          <div class="form-group pl-16 pr-16">
            <div class="form-row">
              <div class="col-md-12">
                <label for="listFolders" class="input-label">Folder</label>
                <select class="form-control select-input" id="listFolders" formControlName="listFolders">
                  <option value="0" hidden>Select Folder</option>
                  <option *ngFor="let folder of _listFolderSelectListOptions" [ngValue]="folder.value">
                    {{folder.label}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <label for="lists" class="input-label">List</label>
                <select class="form-control select-input" id="lists" formControlName="lists">
                  <option value="0" hidden>Select List</option>
                  <option *ngFor="let list of _listsSelecListOptions" [ngValue]="list.value">
                    {{list.label}}
                  </option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <label for="listFields" class="input-label">Field</label>
                <select class="form-control select-input" id="listFields" formControlName="listFields">
                  <option value="0" hidden>Select Field</option>
                  <option *ngFor="let option of _listFieldsSelectListOptions" [ngValue]="option.value">
                    {{option.label}}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" mdbBtn color="secondary" class="waves-light btn-cancel-modal" aria-label="Close"
            (click)="insertWildcardModal.hide()">Close</button>
          <button type="submit" [disabled]="!_formGroupInsertWildcard.valid" mdbBtn color="primary"
            class="relative waves-light btn-insert-modal">Insert</button>
        </div>
      </form>
    </div>
  </div>
</div>
